import axios from "axios"
import store from "../store"
import router from "../router"

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "https://api.zhongkepeili.cn/api",
  timeout: 5000,
  headers: { "Content-Type": "application/json;charset=utf-8" }
})

request.interceptors.request.use(
  config => {
    const token = store.state.token || localStorage.getItem("token")
    console.log("=== 请求拦截器 ===")
    console.log("Store token:", store.state.token ? `${store.state.token.substring(0, 20)}...` : "null")
    console.log("LocalStorage token:", localStorage.getItem("token") ? `${localStorage.getItem("token").substring(0, 20)}...` : "null")
    console.log("使用的 token:", token ? `${token.substring(0, 20)}...` : "null")
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      console.log("已设置 Authorization header")
    } else {
      console.warn("⚠️ 没有 token，请求可能会失败！")
    }
    
    console.log("发送请求:", {
      method: config.method,
      url: config.url,
      baseURL: config.baseURL,
      fullURL: `${config.baseURL}${config.url}`,
      params: config.params,
      hasToken: !!token,
      hasAuthHeader: !!config.headers.Authorization
    })
    return config
  },
  error => {
    console.error("请求错误:", error)
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  response => {
    console.log("收到响应:", {
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
      config: {
        method: response.config.method,
        url: response.config.url,
        baseURL: response.config.baseURL,
        fullURL: `${response.config.baseURL}${response.config.url}`
      },
      data: response.data
    })
    const res = response.data
    if (res.code !== undefined && res.code !== 200 && res.code !== 201) {
      if (res.code === 401) {
        store.dispatch("logout")
        router.push("/login")
      }
      return Promise.reject(new Error(res.message || "请求失败"))
    }
    return res
  },
  error => {
    console.error("响应错误:", {
      message: error.message,
      config: error.config
        ? {
            method: error.config.method,
            url: error.config.url,
            baseURL: error.config.baseURL,
            fullURL: `${error.config.baseURL}${error.config.url}`
          }
        : null,
      response: error.response
        ? {
            status: error.response.status,
            statusText: error.response.statusText,
            data: error.response.data
          }
        : null
    })

    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.dispatch("logout")
          router.push("/login")
          break
        case 403:
          console.error("没有权限访问")
          break
        case 404:
          console.error("请求的资源不存在")
          break
        case 500:
          console.error("服务器内部错误")
          break
        default:
          break
      }
    }
    return Promise.reject(error)
  }
)

export default request
